import DeleteAssetModal from '../common/DeleteAssetModal';

export default {
  DeleteAssetModal
};
